export enum LogLevel{
    None = 0,
    Error = 1,
    Warning = 2,
    Info = 3,
    Debug = 4
}
